<template>
  <div id="app">
    <NavHeader></NavHeader>
    <IssueViewer></IssueViewer>
  </div>
</template>

<script>
import NavHeader from "./components/NavHeader";
import IssueViewer from "./components/IssueViewer";
import {GitlabClient} from './lib/gitlab-client';

import config from "@/config";

const axios = require('axios').default;

export default {
  name: 'App',
  components: {
    NavHeader,
    IssueViewer,
  },
  data: () => {
    return {
      milestoneTypes: [
        {value: 'project', text: "Projects"},
        {value: 'group', text: 'Groups'}
      ],

      serverUrl: config.gitlab_url,

      selectedMilestoneType: 'project',
      selectedResource: undefined,
      selectedMilestone: undefined,

      loading: false,
    }
  },
  methods: {
    milestoneTypeChanged() {
      this.selectedResource = undefined;
      this.selectedMilestone = undefined;
    },
  },
  computed: {
    filterResource() {
      if (this.selectedMilestoneType === "project") {
        return this.projects;
      } else if (this.selectedMilestoneType === "group") {
        return this.groups;
      }
      return [];
    },
    http() {
      return axios.create({
        baseURL: `${this.serverUrl}/api/v4`,
        timeout: 5000,
        headers: {
          'Authorization': `Bearer ${this.$auth.accessToken}`
        }
      });
    },
    gitlabClient() {
      console.log('Get client', this.serverUrl, this.$auth.accessToken)
      if (!this.serverUrl || !this.$auth.accessToken) {
        return undefined;
      }
      return new GitlabClient(this.serverUrl, this.$auth.accessToken);
    }
  },
  asyncComputed: {
    projects() {
      console.log('fetch Projects')
      this.loading = true
      this.selectedProject = undefined
      if (!this.gitlabClient) {
        return []
      }
      return this.gitlabClient.projects().finally(() => this.loading = false);
    },
    groups() {
      console.log('fetch groups')
      this.loading = true;
      this.selectedGroup = undefined
      if (!this.serverUrl) {
        return []
      }
      return this.gitlabClient.groups().finally(() => this.loading = false);
    },
    issues() {
      if (!this.selectedResource || !this.selectedMilestone) {
        return [];
      }

      console.log(`Fetching ${this.selectedResource} milestone ${this.selectedMilestone}`)

      this.loading = true
      return this.gitlabClient.issues(this.selectedResource, this.selectedMilestoneType, this.selectedMilestone).finally(() => this.loading = false)
    },
    labels() {
      if (!this.selectedResource || !this.gitlabClient) {
        return []
      }
      return this.gitlabClient.labels(this.selectedResource, this.selectedMilestoneType);
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
